import forge from 'node-forge'

const REACT_APP_API_PUBLIC_KEY =
    '-----BEGIN PUBLIC KEY-----\r\\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAm9AY21VM9wOR/U5wdPNq\r\\nGrGNRBrsYbJ8WXhpeqvTH+rqL+KRqDHAd4zXD9vUcV70MZnD7Jcu6UkNV3W9yD5H\r\\nCVQowZi3qxP8fzpduzFnB/33UplkeNdkfbDctFV9NFr9YWhC8ZPMaSDU2hovnvWB\r\\n80fuIUKThg7PZkYM7e3crsbMPx3ghLgGoriVYEPg3dZql7UztrNFRm9ujTo94eZO\r\\n6Htxej60na06BBd85C8k2osDiD9Pn0QnHLW7wtgtyP0uXV0sl5EiuOYv4az6yQzd\r\\n+I2NWVRYUqEZgfn8DNMmwFdXiPvn25l1WopaTjoydQr8S+8iAGpYbde9B6YmNbh8\r\\n2wIDAQAB\r\\n-----END PUBLIC KEY-----\r\\n'

export const encrypt_forge = (payload) => {
    const publicKeyPem = REACT_APP_API_PUBLIC_KEY.replace(/\\n/g, '\n')
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem)

    let objJsonStr = JSON.stringify(payload)
    const encryptedPayload = publicKey.encrypt(objJsonStr, 'RSA-OAEP', {
        md: forge.md.sha256.create(), // Use SHA-256 for hashing
    })
    const encryptedPayloadBase64 = forge.util.encode64(encryptedPayload)

    return encryptedPayloadBase64
}
